import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { width, textColor, isMethodPage } = {}) => ({
    text: {
      color: textColor,
      lineHeight: '16px',
      maxWidth: isMethodPage ? '80%' : '100%',
      wordBreak: 'break-word',
    },
    secondaryText: { color: '#929A92' },
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: 14,
      position: 'relative',
      width,
      [theme.breakpoints.down('lg')]: {
        display: 'block',
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.down('md')]: {
        alignItems: 'start',
        display: 'flex',
        fontSize: 10,
        lineHeight: '12px',
        marginBottom: 6,
      },
    },
    title: {
      fontWeight: 'bold',
      minWidth: 'max-content',
      marginBottom: theme.spacing(0.5),
    },
    editIcon: {
      cursor: 'pointer',
      height: 12,
      width: 12,
      marginLeft: theme.spacing(1),
      '& path': {
        fill: theme.palette.primary1,
      },
    },
  }),
);
